import React from "react";

const FONT_FAMILY = "AdigianaUI";
const FONT_URL = "/assets/fonts/AdigianaUI.ttf";
const FONT_STACK = `"${FONT_FAMILY}"`;
const FONT_FACE_ID = "pinterest-template9-adigiana-font-face";

const OVERLAY_SRC = "/assets/templates/pinterest-template9-overlay.svg";

// Black outline built from 8 offset copies behind the white fill — more reliable under
// html2canvas capture than -webkit-text-stroke or text-shadow, which it renders inconsistently.
const OUTLINE_OFFSETS = [
  [-3, -3], [0, -3], [3, -3],
  [-3, 0], [3, 0],
  [-3, 3], [0, 3], [3, 3]
];

function useLocalFont() {
  if (typeof document !== "undefined") {
    if (!document.getElementById(FONT_FACE_ID)) {
      const style = document.createElement("style");
      style.id = FONT_FACE_ID;
      style.textContent = `
        @font-face {
          font-family: "${FONT_FAMILY}";
          src: url("${FONT_URL}") format("truetype");
          font-weight: normal;
          font-style: normal;
          font-display: block;
        }
      `;
      document.head.appendChild(style);
    }
    // Kick off the font fetch/parse immediately so it's ready well before html2canvas
    // captures the DOM (capture happens after images load, so this has ample time).
    if (document.fonts && document.fonts.load) {
      document.fonts.load(`52px "${FONT_FAMILY}"`).catch(() => {});
    }
  }
}

export default function PinterestPinTemplate9({
  foodImageUrl1,
  foodImageUrl2,
  title = "Crockpot Mississippi Meatloaf",
  focusKeyword
}) {
  useLocalFont();

  const displayTitle = focusKeyword || title;
  const bgImage2 = foodImageUrl2 || foodImageUrl1;

  const titleTextStyle = {
    fontFamily: FONT_STACK,
    fontWeight: "normal",
    fontSize: 52,
    lineHeight: 1.4,
    textAlign: "center",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
  };

  return (
    <div
      id="pinterest-pin-template"
      style={{
        width: 1080,
        height: 1920,
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f6f2e7",
        WebkitFontSmoothing: "antialiased"
      }}
    >
      {/* ===== LAYER 1: TOP ARTICLE IMAGE ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 1080,
          height: 960,
          overflow: "hidden",
          backgroundColor: "#c8a882"
        }}
      >
        {foodImageUrl1 && (
          <img
            src={foodImageUrl1}
            alt=""
            crossOrigin="anonymous"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block"
            }}
          />
        )}
      </div>

      {/* ===== LAYER 2: BOTTOM ARTICLE IMAGE ===== */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 960,
          width: 1080,
          height: 960,
          overflow: "hidden",
          backgroundColor: "#b89060"
        }}
      >
        {bgImage2 && (
          <img
            src={bgImage2}
            alt=""
            crossOrigin="anonymous"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
              display: "block"
            }}
          />
        )}
      </div>

      {/* ===== LAYER 3: FIXED SVG OVERLAY (unmodified design asset) ===== */}
      <img
        src={OVERLAY_SRC}
        alt=""
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 1080,
          height: 1920,
          zIndex: 10,
          pointerEvents: "none"
        }}
      />

      {/* ===== LAYER 4: DYNAMIC TITLE — centered in the middle red banner ===== */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: 922,
          transform: "translate(-50%, -50%)",
          width: 660,
          zIndex: 20
        }}
      >
        <div style={{ position: "relative", width: 660 }}>
          {/* Every layer below shares the same explicit width so line-wrapping is
              identical across all of them — offsetting via "left/top" (rather than
              "transform") changes each copy's shrink-to-fit available width and made
              copies wrap onto a different number of lines than the visible text. */}
          {OUTLINE_OFFSETS.map(([dx, dy]) => (
            <div
              key={`${dx}-${dy}`}
              aria-hidden="true"
              style={{
                ...titleTextStyle,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                width: 660,
                transform: `translate(${dx}px, ${dy}px)`,
                color: "#000000",
                zIndex: 0
              }}
            >
              {displayTitle}
            </div>
          ))}
          <div
            style={{
              ...titleTextStyle,
              position: "relative",
              width: 660,
              color: "#ffffff",
              zIndex: 1
            }}
          >
            {displayTitle}
          </div>
        </div>
      </div>
    </div>
  );
}
